import { useTranslation } from 'react-i18next';
import type { Site } from '../types';

export interface SiteExcelData {
  siteName: string;
  currentState: string;
  priority: string;
  totalPrice: string;
}

export const useExcelFormat = () => {
  const { t } = useTranslation();

  const currencyFormat = (value: number) => {
    return value.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const formatSitesTable = (sites: Site[]): SiteExcelData[] => {
    return sites.map(site => ({
      siteName: site.siteName,
      currentState: site.currentState,
      priority: site.priority?.toString() || '1',
      totalPrice: currencyFormat(site.totalPrice || 0),
    }));
  };

  const formatTableWithHeaders = (data: SiteExcelData[]) => {
    return data.map(item => ({
      [t('siteName_export_table', 'Site Name')]: item.siteName,
      [t('currentState_export_table', 'Current State')]: t(
        item.currentState,
        item.currentState
      ),
      [t('priority_export_table', 'Priority')]: item.priority,
      [t('totalPrice_export_table', 'Total Price')]: item.totalPrice,
    }));
  };

  return {
    formatSitesTable,
    formatTableWithHeaders,
    currencyFormat,
  };
};
